import * as React from 'react';
import partial from 'transmute/partial';
import ConnectorButton from 'automation-ui-canvas/components/canvas/ConnectorButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ContextualCanvasAddButton = ({
  disabled = false,
  disabledMessage = null,
  edge,
  flowId,
  isMulti,
  showEdgeTooltips,
  onClick
}) => {
  return /*#__PURE__*/_jsx(ConnectorButton, {
    edge: edge,
    isMulti: isMulti,
    flowId: flowId,
    showEdgeTooltips: showEdgeTooltips,
    onClick: partial(onClick, edge.getId()),
    "data-test-id": `single-connector-${edge.getId()}`,
    disabled: disabled,
    tooltip: disabled && disabledMessage,
    placement: "left"
  });
};
export default ContextualCanvasAddButton;